// extracted by mini-css-extract-plugin
export default {"tips":"hIuz0","tipsGallery":"Jf9y5","tipsBlock":"LPkA7","tipsName":"wpSmz"};